import { Link } from 'react-router-dom';
import { Badge, ProgressBar } from '@dreamtree-org/twreact-ui';
import { CheckCircle2, Circle, ChevronRight } from 'lucide-react';
import { checklistOrder } from '../lib/dashboard';

/**
 * "Get your store ready" (MERCH-58): the server's setup checklist (Location.checklist,
 * lib/store/setup), open items first. Each row links to the screen that completes it.
 */
export default function SetupChecklist({ data }) {
  if (!data) return null;
  const items = checklistOrder(data.items);
  return (
    <div className="space-y-3">
      <ProgressBar value={data.done} max={data.total || 1} variant={data.complete ? 'success' : 'primary'} size="sm" showValue={false} ariaLabel={`${data.done} of ${data.total} setup steps done`} />
      <p className="text-sm opacity-70">{data.complete ? 'Your store is ready for its first order.' : `${data.done} of ${data.total} steps done. Finish these to take your first order.`}</p>
      <ul className="divide-y divide-[var(--app-border)]" data-testid="setup-checklist">
        {items.map((i) => (
          <li key={i.key}>
            <Link to={i.path} className="flex items-center gap-3 py-2 min-h-[44px] hover:opacity-80">
              {i.done ? <CheckCircle2 size={18} className="shrink-0 text-success-600" aria-label="Done" /> : <Circle size={18} className="shrink-0 opacity-50" aria-label="To do" />}
              <span className="min-w-0 flex-1">
                <span className={`block font-medium ${i.done ? 'opacity-70' : ''}`}>{i.label}</span>
                <span className="block text-xs opacity-70">{i.detail}</span>
              </span>
              {i.optional ? <Badge size="sm" variant="outline">Optional</Badge> : null}
              <ChevronRight size={16} className="shrink-0 opacity-50" aria-hidden />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
